import { api } from '../axios'
import type { ApiResponse, District } from '../../../types'

export const districtsApi = {
  getAll: () =>
    api.get<ApiResponse<District[]>>('/districts'),

  getAllIncludingInactive: () =>
    api.get<ApiResponse<District[]>>('/districts/all'),

  getById: (id: number) =>
    api.get<ApiResponse<District>>(`/districts/${id}`),

  create: (data: District) =>
    api.post<ApiResponse<District>>('/districts', data),

  update: (id: number, data: Partial<District>) =>
    api.put<ApiResponse<District>>(`/districts/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/districts/${id}`),
  
  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/districts/${id}/permanent`),
}

